"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('numberExpression'),
    title: 'Number expression',
    anyOf: [
        { type: 'number' },
        { $ref: jsonschema_1.$id('sumExpression') },
        { $ref: jsonschema_1.$id('productExpression') },
        { $ref: jsonschema_1.$id('inverseExpression') },
        { $ref: jsonschema_1.$id('untypedResolvedExpression') }
    ]
};
exports.default = schema;
//# sourceMappingURL=number.schema.js.map